module.exports = __webpack_public_path__ + "static/media/Icon__A.d9e1e35b.png";